<template>
  <div class="sb_modal">
    <div class="sb_modal_background" @click="setModalData(null)" />
    <div class="sb_modal_container">
      <div class="sb_modal_title">
        <Title><span v-html="title"/></Title>
      </div>
      <div class="sb_modal_content">
        <span v-html="content" />
      </div>
      <div class="sb_modal_buttons" :class="{ s_cancel: cancelButton }">
        <Button icon-right="icon_arrow-right" v-if="cancelButton" type="cancel" @click.native="setModalData(null)">
          <span class="sb_modal_buttons_cancel-content">{{ cancelButton ? cancelButton : 'annuleer' }}</span>
        </Button>
        <Button @click.native="handleClick">
          <span class="sb_modal_buttons_ok-content">{{ button ? button : 'ok' }}</span>
          <template slot="icon-right">
            <SvgIcon class="sb_modal_buttons_ok-icon" icon="arrow-right" />
          </template>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'modal',
  computed: {
    ...mapState('modal', ['title', 'content', 'cancelButton', 'button', 'callback']),
  },
  methods: {
    ...mapMutations('modal', ['setModalData']),
    handleClick() {
      if (this.callback) {
        this.callback();
      }

      this.setModalData(null);
    },
  },
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .sb_modal {
    z-index: 1001;
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    &_title {
      border-bottom: 2px solid $brand-lightest-gray;
      padding: 0 0 1.2rem 0.4rem;
      display: flex;
      justify-content: space-between;
      &_icon {
        font-size: 1.6rem;
        color: $brand-red;
      }
    }
    &_content {
      margin-top: 1rem;
      padding-left: 0.4rem;
      line-height: 1.8;
      > span {
        display: inline-block;
        padding: 1rem 0;
      }
    }
    &_background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba($brand-black, 0.4);
    }
    &_buttons {
      margin-top: 1rem;
      padding-top: 1.4rem;
      border-top: 2px solid $brand-lightest-gray;
      display: flex;
      justify-content: flex-end;
      &.s_cancel {
        justify-content: space-between;
      }
      .sb_button {
        padding: 1rem;
      }
      &_ok-icon {
        color: $brand-white;
      }
      @include media('<=medium-portrait') {
        flex-direction: column;
        &.s_cancel {
          button:last-child {
            margin-top: 0.4rem;
          }
        }
      }
    }
    &_container {
      position: relative;
      max-width: 90%;
      padding: 1.4rem 1.8rem;
      background: $brand-white;
      border-radius: $default-radius;
      box-shadow: 0 6px 14px 3px rgba($brand-black, 0.4);
      @include media('>=medium') {
        max-width: 600px;
      }
    }
  }
}
</style>
